module.exports = __webpack_public_path__ + "img/01-bk-city-front-buildings.b4a87246.svg";